import {
  Card,
  CardHeader,
  CardBody,
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Button,
  Col,
  Row
} from "reactstrap";
import TextEditor from "components/editor/TextEditor";
import { useFormik } from "formik";
import * as Yup from "yup";
import { httpRequest } from "utils/httpRequest";
import {useParams,useNavigate} from "react-router-dom"
import {useState,useEffect} from "react"
import {toast} from "react-toastify"

const AddChapter = () => {




  const {id}=useParams()
  const navigate=useNavigate()
  // Formik validation schema
  const validationSchema = Yup.object().shape({
    title: Yup.string()
      .required("Chapter title is required")
      .min(3, "Title must be at least 3 characters"),
    description: Yup.string()
        .required("Chapter Description is required")
        .test('not-empty-html', 'Chapter Description is required', function(value) {
          if (!value) return false;
          // Remove HTML tags and check if there's actual content
          const textOnly = value.replace(/<[^>]*>/g, '').trim();
          return textOnly.length > 0;
        })
      
  });

  const formik = useFormik({
    initialValues: {
      title: "",
      description: ""
    },
    validationSchema,
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit:async (values) => {
      formik.setTouched({

        title: true,
        description: true
      });

      const errors = await formik.validateForm();

      if (Object.keys(errors).length > 0) return false;

      try {
       

        const response = await httpRequest(
          `chapter/update/${id}`,
          "PATCH",
          {
            title: values?.title,
            content: values?.description,
            
          },
          {},
          true,
          true
        );
        if (response?.code === 200) {
          
          toast.success("Chapter updated successfully")
          navigate(-1)



        }

      } catch (error) {
        console.log(error);
       
      }
      // Handle form submission here
    }
  });




const getChapterEditData=async()=>{
try {

      const response = await httpRequest(
        `chapter/get/${id}`,
        "GET",
        {},
        {},
        true,
        false
      );
      if (response?.code === 200) {
        



        formik.resetForm({
          values: {
            title: response?.data?.title,
            description: response?.data?.content,
            
          }
        });

      }
    } catch (error) {
      console.log("Upload error:", error);
     
    }
}


useEffect(()=>{
if(id){
  getChapterEditData()
}
},[id])









  return (
    <Row className="mt-4 justify-content-center">
      <Col lg="8" md="8" className="mx-auto mt-4">
        <Card className="bg-secondary shadow border-0">
          <CardHeader className="bg-transparent pb-3">
            <div className="text-muted text-center mt-2 mb-3">
              <small>Edit Chapter</small>
            </div>
          </CardHeader>
          <CardBody className="px-lg-5 py-lg-4">
            <Form onSubmit={formik.handleSubmit}>
              <FormGroup className="mb-3">
                <InputGroup className="input-group-alternative">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="ni ni-book-bookmark" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    placeholder="Chapter Title"
                    type="text"
                    name="title"
                    value={formik.values.title}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </InputGroup>
                {formik.touched.title && formik.errors.title && (
                  <div className="text-danger small mt-1">
                    {formik.errors.title}
                  </div>
                )}
              </FormGroup>

              <FormGroup>
                <label className="form-control-label">Chapter Description</label>
                <TextEditor
                  value={formik.values.description}
                  onChange={(html) =>{
                    formik.setFieldValue("description", html)
                    setTimeout(() => {
                      formik.setFieldTouched("description", true);
                      formik.validateField("description");
                    }, 100);
                  }
                  }
                    
                  
                  onBlur={() =>{ 
                    formik.setFieldTouched("description", true)
                    formik.validateField("description");
                  }}
                  placeholder="Write the chapter description..."
                  hideImageAndLink={true}
                />
                {formik.touched.description && formik.errors.description && (
                  <div className="text-danger small mt-1">
                    {formik.errors.description}
                  </div>
                )}
              </FormGroup>

              <div className="text-center">
                <Button className="my-4" color="primary" type="submit">
                  Save Chapter
                </Button>
              </div>
            </Form>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default AddChapter;